export default {
  getRelated(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/courses/related/${productId}?limit=100`)
        .then(response => {
          context.commit("setRelatedCourses", response.data.results);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  }
};
